import { render, staticRenderFns } from "./DisplayPtree.vue?vue&type=template&id=5f431d80&scoped=true&"
import script from "./DisplayPtree.vue?vue&type=script&lang=js&"
export * from "./DisplayPtree.vue?vue&type=script&lang=js&"
import style0 from "./DisplayPtree.vue?vue&type=style&index=0&id=5f431d80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f431d80",
  null
  
)

export default component.exports